import { TabBarState } from 'src/pages/types';
import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const tabBarSelector = (state: RootState): TabBarState => state.tabBar;
